import React from 'react';
import Breadcrumbs from './Breadcrumbs';
import Switcher from './Switcher';
import panel from './Panel.module.scss';
// import { ReactComponent as Search } from '../styles/icon/search.svg';
// import { ReactComponent as Keyboard } from '../styles/icon/keyboard.svg';

const PanelContainer = () => {
  return (
    <div className={panel.panel}>
      <div className={panel.panel__container}>
        <Breadcrumbs />
        <div className={panel.panel__right}>
          {/* <i className={panel.panel__search}>
            <Search />
          </i>
          <i className={panel.panel__keyboard}>
            <Keyboard />
          </i> */}
          <Switcher handleDiameter={24} height={16} width={38} />
        </div>
      </div>
    </div>
  );
};

export default PanelContainer;
